import React from "react";
import ReactDOM from "react-dom";
import MessageBox from "../messagebox";
import HcsControl from "./hcs-control";

// Simple control which only renders a static text.
export default class HcsStatic extends HcsControl {
    constructor(props) {
        super(props);

        this.inlineButtonClick = this.inlineButtonClick.bind(this);
    }

    childClass() {
        const { data } = this.props;

        let cssClasses = ["hcs-static"];

        switch(data.data.CFG_CONTROL) {
            case "HEADLINE":
                cssClasses.push("hcs-ecs-headline");
                break;

            case "DYNAMIC":
                cssClasses.push("hcs-dynamic");
                break;

            case "ERROR":
                cssClasses.push("hcs-error");
                break;
        }

        if(data.data.BDATA5) {
            cssClasses.push(data.data.BDATA5);
        }

        return cssClasses.join(" ");
    }

    /**
     * Handle click of inline buttons.
     * @param {string} flagReference - Name of the attribute in "data.flags" which contains the
     * text being displayed.
     */
    inlineButtonClick(flagReference) {
        const { hcs, data } = this.props;

        const popupText = data.flags[flagReference];

        hcs.messageBox.show({
            modal: true,
            text: popupText,
            buttons: MessageBox.MB_OK,
            messageType: null
        });
    }

    /**
     * Parse display text in "data.trans" und handle special controls like buttons.
     */
    registerInlineControls() {
        let self = this;

        const { data } = this.props;

        let htmlContent = ReactDOM.findDOMNode(this);

        if(htmlContent) {
            let popupButtons = htmlContent.querySelectorAll("button[text-type][text-source]");

            popupButtons.forEach(button => {
                switch(button.getAttribute("text-type")) {
                    case "popup":
                        let textSource = button.getAttribute("text-source");

                        if(textSource) {
                            if(data.flags && data.flags[textSource]) {
                                button.addEventListener("click", _ => self.inlineButtonClick(textSource));
                            } else {
                                console.warn(`Static control '${data.ident}' has a 'text-type' button whose 'text-source' reference '${textSource}' is not included in 'flags'!`);
                            }
                        } else {
                            console.warn(`Static control '${data.ident}' with 'text-type'='popup' requires a 'text-source' attribute!`);
                        }
                        break;
                }
            });
        }
    }

    componentDidMount() {
        this.registerInlineControls();
    }

    componentDidUpdate() {
        this.registerInlineControls();
    }

    render() {
        const { data } = this.props;

        return super.render(<div dangerouslySetInnerHTML={{ __html: data.info.trans }} />);
    }
}